__turbopack_context__.v({
  "className": "noto_sans_thaana_a58c026c-module__74DAna__className",
});
